
import { Injectable } from '@angular/core';
import type { IAuthService, IAuthUser } from '../../auth/auth.interface';
import { CognitoService } from './cognito.service';

@Injectable({
  providedIn: 'root',
})
export class CognitoAuthService implements IAuthService {

  constructor(private cognitoService: CognitoService) {}

  getUser(): Promise<any> {
    return this.cognitoService.getUser();
  }

  /**
   * No-op for Cognito — Amplify is configured inside CognitoService constructor.
   */
  initialize(): Promise<boolean> {
    return Promise.resolve(true);
  }

  /** Delegates to CognitoService.signIn(). */
  signIn(user: IAuthUser): Promise<any> {
    return this.cognitoService.signIn(user);
  }

  /** Delegates to CognitoService.signOut(). */
  signOut(): Promise<any> {
    return this.cognitoService.signOut();
  }

  /** Delegates to CognitoService.isAuthenticated(). */
  isAuthenticated(): Promise<boolean> {
    return this.cognitoService.isAuthenticated();
  }

  /** Returns the Cognito ID token from session storage. */
  getIdToken(): string | null {
    return this.cognitoService.getCognitoIdToken();
  }

  /** Returns the Cognito access token from session storage. */
  getAccessToken(): string | null {
    return this.cognitoService.getCognitoAccessToken();
  }

  /** Delegates token-validity check + background refresh to CognitoService. */
  isTokenValid(): boolean {
    return this.cognitoService.isTokenValid();
  }

  /** Starts the proactive Cognito token-refresh interval. */
  startTokenRefreshInterval(): void {
    this.cognitoService.startTokenRefreshInterval();
  }
}
